import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchResultComponent } from '@softapps/core';
import { I18nModule } from '@softline/ui-core';
import { Lagerplatz } from '../../../types/lagerplatz';

@Component({
  selector: 'soft-search-result-view',
  imports: [CommonModule, I18nModule],
  templateUrl: './search-result-view.component.html',
  styleUrl: './search-result-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LagerplatzFieldOkSearchResultViewComponent
  implements SearchResultComponent<Lagerplatz>
{
  readonly result = input.required<Lagerplatz>();
}
